import style from "./technology-stack.module.scss";
import Image from "next/image";
import SharedAnimation from "@components/shared/animation";
import { InView } from "react-intersection-observer";
import animations from "@styles/animations.module.scss";
import { ITechnologyStack } from "../givingli.content";

type TechnologyStackProps = {
    technologyStack: ITechnologyStack[];
}

const TechnologyStack  = ({ technologyStack }: TechnologyStackProps) => {
  return (
    <SharedAnimation
      render={() => (
        <section className={`${style.section} ${style.section__info}`}>
          <div className={style.techStack__title}>Technology stack used</div>
          <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
              if (inView) {
                entry?.target.classList.add(animations.active);
              }
              return (
                <div ref={ref} className={`${style.techStack__grid} ${animations.scroll__animation}`}>
                  {technologyStack.map((block, blockIndex) => (
                    <div key={blockIndex} className={style.techStack__row}>
                      <div className={style.techStack__category}>
                        {block.title}
                      </div>

                      <div className={style.techStack__items}>
                        {block.items.map((item, itemIndex) => (
                          <div
                            key={itemIndex}
                            className={style.techStack__item}
                          >
                            <div className={style.techStack__item__image}>
                              <Image
                                src={item.image}
                                alt={item.name}
                                width={item.width}
                                height={item.height}
                              />
                            </div>

                            <span className={style.techStack__items__name}>
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              );
            }}
          </InView>
        </section>
      )}
    />
  );
};

export default TechnologyStack;
